import {
  dashboardSectionCardClassName,
  dashboardSectionCardContentClassName,
  dashboardSectionCardFillClassName,
  dashboardSectionCardHeaderClassName,
} from "@/modules/dashboard/presentation/ui/dashboard-card-styles";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  cn,
  Skeleton,
} from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";

type PerformanceDashboardSectionCardProps = {
  title: ReactNode;
  viewAllTo: string;
  isLoading?: boolean;
  isEmpty?: boolean;
  emptyMessage?: string;
  skeletonRows?: number;
  children: ReactNode;
};

export function PerformanceDashboardSectionCard({
  title,
  viewAllTo,
  isLoading,
  isEmpty,
  emptyMessage = "ບໍ່ມີລາຍການຄ້າງ",
  skeletonRows = 3,
  children,
}: PerformanceDashboardSectionCardProps) {
  const nav = useNavigate();

  return (
    <Card
      className={cn(
        dashboardSectionCardClassName,
        dashboardSectionCardFillClassName,
      )}
    >
      <CardHeader
        className={cn(
          dashboardSectionCardHeaderClassName,
          "flex flex-row flex-wrap items-center justify-between gap-2 space-y-0",
        )}
      >
        <CardTitle className="text-base">{title}</CardTitle>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="shrink-0"
          onClick={() => void nav({ to: viewAllTo })}
        >
          ເບິ່ງທັງໝົດ
        </Button>
      </CardHeader>
      <CardContent
        className={cn(dashboardSectionCardContentClassName, "min-h-0 flex-1")}
      >
        {isLoading ? (
          <ul className="flex flex-col gap-2">
            {Array.from({ length: skeletonRows }).map((_, i) => (
              <li
                key={`sk-${i}`}
                className="rounded-lg border px-3 py-3"
              >
                <Skeleton className="mb-2 h-4 w-48" />
                <Skeleton className="h-3 w-32" />
              </li>
            ))}
          </ul>
        ) : isEmpty ? (
          <div className="rounded-lg bg-muted/40 px-4 py-8 text-center text-muted-foreground text-sm">
            {emptyMessage}
          </div>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
}

export const performanceQueueItemClassName =
  "flex flex-col gap-2 rounded-lg border bg-card px-3 py-3 transition-colors hover:border-primary/25 hover:bg-muted/30 sm:flex-row sm:items-center sm:justify-between";
